import { useReactiveVar } from "@apollo/client";
import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { whiteLabelLimitModalVar } from "../../../graphql/globalVar/state";
import useGetUrlLocale from "../../../hooks/useGetUrlLocale";

function WhiteLabelLimitModal() {
  const type = useReactiveVar(whiteLabelLimitModalVar);
  const { t } = useTranslation();
  const locale = useGetUrlLocale();

  const handleClose = () => whiteLabelLimitModalVar(null);

  return (
    <Modal
      show={type !== null}
      onHide={handleClose}
      centered
      contentClassName="rounded-4 border-0"
    >
      <Modal.Header closeButton className="border-0 p-3">
        <Modal.Title className="fw-bold fs-5">
          {t("events.modals.whiteLabelLimit.title")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-3 px-4 fs-6 text-dark">
        {type === "free"
          ? t("events.modals.whiteLabelLimit.freeBody")
          : t("events.modals.whiteLabelLimit.proBody")}
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0 px-4 pb-4 d-flex gap-2 justify-content-end">
        {type === "free" && (
          <Link
            to={`${locale}/payment`}
            className="btn btn-success text-white rounded-3 px-4"
            onClick={handleClose}
          >
            {t("events.modals.whiteLabelLimit.upgradePro")}
          </Link>
        )}
        <Button
          variant="outline-secondary"
          className="rounded-3 px-4"
          onClick={handleClose}
        >
          {t("events.modals.whiteLabelLimit.gotIt")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default WhiteLabelLimitModal;
